import { defineAsyncComponent } from 'vue';

export default function useCustomActionBox(props, name) {
  // todo: refactor to dynamically include named boxes
  if (!name) {
    name = props.models.meta.modelNamePlural;
  }
  const customActionBox = (aspect) => {
    try {
      require(`@/aspects/${aspect}/Pages/${name}/CustomActionBox.vue`);

      return defineAsyncComponent(() => import(`@/aspects/${aspect}/Pages/${name}/CustomActionBox.vue`));
    } catch (e) {
      //
    }
  };

  return {
    customActionBox,
  };
}
